
import { storage } from '../../lib/firebase';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

export const uploadDeliveryFile = async (file: File, path?: string): Promise<string> => {
  const storageRef = ref(storage, path || `deliveries/${Date.now()}_${file.name}`);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
};

export const deleteFile = async (url: string) => {
    if (!url) return;
    try {
        // Create a reference from the full download URL
        const storageRef = ref(storage, url);
        await deleteObject(storageRef);
    } catch (error: any) {
        // Ignore "Object not found" errors (404) to allow DB cleanup to proceed if file is already gone
        if (error.code !== 'storage/object-not-found') {
            console.error("Error deleting file from storage:", error);
        }
    }
};
